import Navigation from "./js/menu"
import closeButtons from "./js/close-button"
import GameMap from "./js/game-map"
import GameQuizz, * as Quizz from "./js/game-quizz"
import Modal from "./js/modal"

document.addEventListener("DOMContentLoaded", function () {
	Navigation.init()
	closeButtons.bindEvents()
	Modal.bindEvents()
})

window.addEventListener("load", function () {
	GameMap.init()
	GameQuizz.init()
})
